// extracted by mini-css-extract-plugin
export default {"claimsSpin":"claimsSpin__Z4ZRVm","claimStatus":"claimStatus__Ftu5b6","title":"title__mAUW5o","switch":"switch__AgN2E4"};